import { Dictionary } from "flow/api/types";
import ko from "knockout";

export interface ICreateViewComponentParams {
    viewModel: any;
}

const registeredComponents: Dictionary<boolean> = {};

function createViewComponent(name: string, viewHtml: string): void {
    if (registeredComponents[name]) {
        // Avoid registering the same component multiple times
        return;
    } else {
        registeredComponents[name] = true;
    }

    ko.components.register(name, {
        viewModel: {
            createViewModel: function (
                params: ICreateViewComponentParams,
                componentInfo: KnockoutComponentTypes.ComponentInfo
            ) {
                if (params && params.viewModel) {
                    return params.viewModel;
                } else {
                    const vm = ko.dataFor(componentInfo.element);
                    return vm;
                }
            }
        },
        template: viewHtml,
        synchronous: true
    });
}

export default createViewComponent;
